import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import searchService from '../../api/searchService';
import clientService from '../../api/clientService';
import { useNotifications } from '../../context/NotificationContext';
import Avatar from '../common/Avatar';
import Field from '../common/Field';
import LoadingSpinner from '../common/LoadingSpinner';
import { currency, toDatetimeLocalValue } from '../../utils/formatters';

export default function BookingForm() {
  const { technicianId } = useParams();
  const navigate = useNavigate();
  const notify = useNotifications();
  const [tech, setTech] = useState(null);
  const [busy, setBusy] = useState(false);

  const tomorrow = new Date(Date.now() + 864e5);
  const [form, setForm] = useState({
    description: '',
    scheduledDate: toDatetimeLocalValue(tomorrow),
    clientAddress: '',
    estimatedCost: '',
    notes: '',
  });
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  useEffect(() => {
    searchService.getTechnician(technicianId).then(setTech).catch((e) => notify.apiError(e));
  }, [technicianId, notify]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await clientService.createBooking({
        technicianId,
        description: form.description,
        // datetime-local value is already an ISO LocalDateTime (no zone) — send as-is.
        scheduledDate: form.scheduledDate.length === 16 ? `${form.scheduledDate}:00` : form.scheduledDate,
        clientAddress: form.clientAddress,
        estimatedCost: form.estimatedCost ? Number(form.estimatedCost) : null,
        notes: form.notes || null,
      });
      notify.success('Booking request submitted — our team will review it before sending it to the technician.');
      navigate('/client/bookings');
    } catch (err) {
      notify.apiError(err);
    } finally {
      setBusy(false);
    }
  };

  if (!tech) return <div className="page"><div className="container"><LoadingSpinner /></div></div>;

  return (
    <div className="page">
      <div className="container auth-wrap wide">
        <div className="card pad">
          <div className="row" style={{ alignItems: 'center', marginBottom: '1rem' }}>
            <Avatar src={tech.profilePictureUrl} name={`${tech.firstName} ${tech.lastName}`} />
            <div>
              <h2>Book {tech.firstName} {tech.lastName}</h2>
              <p className="muted">{tech.technicianTypeName} · {currency(tech.hourlyRate)}/hr</p>
            </div>
          </div>
          <form onSubmit={submit}>
            <Field as="textarea" label="What do you need done?" required value={form.description} onChange={set('description')} maxLength={1000} />
            <div className="form-grid">
              <Field label="Preferred date & time" type="datetime-local" required value={form.scheduledDate} onChange={set('scheduledDate')} />
              <Field label="Estimated budget (optional)" type="number" min="0" step="0.01" value={form.estimatedCost} onChange={set('estimatedCost')} />
            </div>
            <Field label="Service address" required value={form.clientAddress} onChange={set('clientAddress')} />
            <Field as="textarea" label="Notes for the technician (optional)" value={form.notes} onChange={set('notes')} maxLength={2000} />
            <button className="btn accent block" disabled={busy}>
              {busy ? 'Sending…' : 'Send booking request'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
